import { getCurrentUser } from 'nuxt-vuefire/runtime/auth/composables.js'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()

  // redirect the user to the login page
  if (!user) {
    return navigateTo({
      name: 'signin',
      query: {
        redirect: to.fullPath,
      },
    })
  } else if (!user.emailVerified) {
    return navigateTo('/confirm-email')
  }
})
